export default {
  init: function () {
    const AK = 'zpWNUJFZPuNQwW1sGY5DcfTGzI9OYhl0';
    const BMap_URL = `https://api.map.baidu.com/api?v=2.0&ak=${AK}&s=1&callback=onBMapCallback`;
    return new Promise((resolve, reject) => {
    if (typeof BMap !== 'undefined') {
    resolve(BMap);
    return true;
    }
    window.onBMapCallback = function () {
    resolve(BMap);
    };
    let scriptNode = document.createElement('script');
    scriptNode.setAttribute('type', 'text/javascript');
    scriptNode.setAttribute('src', BMap_URL);
    document.body.appendChild(scriptNode);
    });
  }
};